export default __webpack_public_path__ + "static/media/Denims & Cargos.7f6648e3.png";